import { render, staticRenderFns } from "./frontOfertaNegocio.vue?vue&type=template&id=dcdf8c34&scoped=true&"
import script from "./frontOfertaNegocio.vue?vue&type=script&lang=js&"
export * from "./frontOfertaNegocio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdf8c34",
  null
  
)

export default component.exports